export default __webpack_public_path__ + "static/media/email.8ae9a0f3.png";